import { render, staticRenderFns } from "./EmailBroadcastItem.vue?vue&type=template&id=ec64d68e&scoped=true"
import script from "./EmailBroadcastItem.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastItem.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastItem.vue?vue&type=style&index=0&id=ec64d68e&prod&lang=css"
import style1 from "./EmailBroadcastItem.vue?vue&type=style&index=1&id=ec64d68e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec64d68e",
  null
  
)

export default component.exports